import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { UserProvider } from "./context/UserContext";

import Login from "./Login/Login";
import LandingPage from "./components/LandingPage";
import Personal from "./Login/Personal";
import Studio from "./Login/Studio";
import Bank from "./Login/Bank";
import Dashboard from "./Dashboard/Dashboard";
import Deals from "./Dashboard/Deals";
import Upload from "./Dashboard/Upload";
import Schedule from "./Dashboard/Schedule";
import Membership from "./Dashboard/Membership";
import UserFavorites from "./User Dasboard/UserFavorites";
import ProfileSettings from "./User Dasboard/ProfileSettings";
import BrowsePhotographer from "./components/BrowsePhotographer";
import SentRequests from "./User Dasboard/SentRequests";
import CreateAccount from "./Login/CreateAccount";
import PhotographerPortfolio from "./components/PhotographerPortfolio";
import AboutUs from "./components/AboutUs.";
import PhotographProfile from "./Dashboard/PhotographProfile";
import Reviews from "./Dashboard/Reviews";
import PhotographerRequests from "./Dashboard/PhotographerRequests";
import PhotoProfile from "./Dashboard/PhotoProfile";
import EnquiryForm from "./components/EnquiryForm";
import { User } from 'lucide-react';
import UserLogin from './Login/UserLogin';
const App = () => {
  return (
    <UserProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/LandingPage" element={<LandingPage />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Personal" element={<Personal />} />
          <Route path="/Studio" element={<Studio />} />
          <Route path="/Bank" element={<Bank />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/Deals" element={<Deals />} />
          <Route path="/Upload" element={<Upload />} />
          <Route path="/Schedule" element={<Schedule />} />
          <Route path="/Membership" element={<Membership />} />
          <Route path="/UserFavorites" element={<UserFavorites />} />
          <Route path="/ProfileSettings" element={<ProfileSettings />} />
          <Route path="/BrowsePhotographer" element={<BrowsePhotographer />} />
          <Route path="/SentRequests" element={<SentRequests />} />
          <Route path="/CreateAccount" element={<CreateAccount />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/PhotographProfile" element={<PhotographProfile />} />
          <Route path="/Reviews" element={<Reviews />} />
          <Route path="/PhotographerRequests" element={<PhotographerRequests />} />
          <Route path="/PhotoProfile" element={<PhotoProfile />} />
          <Route path="/EnquiryForm" element={<EnquiryForm />} />
          <Route path="/UserLogin" element={<UserLogin />} />

          {/* Photographer Portfolio Routes */}
          <Route path="/PhotographerPortfolio" element={<PhotographerPortfolio />} />
          <Route path="/photographerPortfolio" element={<PhotographerPortfolio />} />
          <Route path="/PhotographerPortfolio/:id" element={<PhotographerPortfolio />} />
          <Route path="/photographer/:photographerId" element={<PhotographerPortfolio />} />
        </Routes>

        {/* ✅ Vercel Analytics & Speed Insights */}
        <Analytics />
        <SpeedInsights />
      </Router>
    </UserProvider>
  );
};

export default App;
